import { render } from "./DataTableLoop.vue?vue&type=template&id=32b9b11e&scoped=true"
import script from "./DataTableLoop.vue?vue&type=script&lang=ts"
export * from "./DataTableLoop.vue?vue&type=script&lang=ts"

import "./DataTableLoop.vue?vue&type=style&index=0&id=32b9b11e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-32b9b11e"

export default script